// src/pages/Unauthorized.jsx
import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { motion } from "framer-motion";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <Box
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      px={2}
    >
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Paper
          elevation={6}
          sx={{
            p: 5,
            borderRadius: 4,
            maxWidth: 480,
            textAlign: "center",
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 80, color: "#e53935", mb: 2 }} />
          <Typography variant="h3" color="error" gutterBottom>
            403
          </Typography>
          <Typography variant="h6" mb={2}>
            Access Denied
          </Typography>
          <Typography variant="body1" mb={4}>
            You do not have the permission to view this page.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/")}
            sx={{ borderRadius: 8, px: 4 }}
          >
            Back to Home
          </Button>
        </Paper>
      </motion.div>
    </Box>
  );
};

export default Unauthorized;
